import React from 'react';
import {MODE_ENTRAINEMENT} from "../../constants";
import CommentIconContainer from "./icons/comment/CommentIconContainer";
import SolutionIconContainer from "./icons/solution/SolutionIconContainer";
import './HelpBox.scss';

const HelpBox = props => {
  const {mode} = props;

  if (mode !== MODE_ENTRAINEMENT) {
    return null;
  }

  return (
    <div className="help-box">
      <div className="help-box__icon-container">
        <CommentIconContainer/>
        <SolutionIconContainer/>
      </div>
    </div>
  )
};

export default HelpBox;
